import { useEffect, useState } from 'react'
import axios from 'axios'
import { GsaFilters, GsaRow, GsaDraft } from './GsaMasCatalog.types'

export function useGsaMasCatalogData(filters: GsaFilters, page: number, pageSize: number) {
  const [rows, setRows] = useState<GsaRow[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  async function load() {
    setLoading(true)
    try {
      const params = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
        awardModNo: filters.awardModNo,
        vendorName: filters.vendorName,
        manufacturerName: filters.manufacturerName,
        mfrPartNo: filters.mfrPartNo,
        productDescription: filters.productDescription,
        contractOfferNo: filters.contractOfferNo,
        vendorPartNo: filters.vendorPartNo,
        uei: filters.uei,
        baseOrAccessory: filters.baseOrAccessory,
        productName: filters.productName,
      })
      const res = await axios.get<{ total: number; list: GsaRow[] }>(`/gsa-mas?${params}`)
      setRows(res.data.list)
      setTotal(res.data.total)
    } catch (err) {
      console.error('Failed to load GSA MAS catalog', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [filters, page, pageSize])

  async function createRow(draft: GsaDraft) {
    try {
      const res = await axios.post<{ id: number }>('/gsa-mas', draft)
      const newRow: GsaRow = { id: res.data.id, ...draft }
      setRows(prev => [...prev, newRow])
      return newRow
    } catch (err) {
      console.error('Failed to create GSA MAS record', err)
      throw err
    }
  }

  async function updateRow(id: number, draft: GsaDraft) {
    try {
      await axios.put(`/gsa-mas/${id}`, draft)
      setRows(prev => prev.map(r => (r.id === id ? { id, ...draft } : r)))
    } catch (err) {
      console.error('Failed to update GSA MAS record', err)
      throw err
    }
  }

  async function deleteRow(id: number) {
    try {
      await axios.delete(`/gsa-mas/${id}`)
      setRows(prev => prev.filter(r => r.id !== id))
    } catch (err) {
      console.error('Failed to delete GSA MAS record', err)
      throw err
    }
  }

  return { rows, total, loading, createRow, updateRow, deleteRow }
}
